import {
  canInitiateNewRoomSessionMatch,
  hasActiveLiveRoomSession,
} from "../../roomGovernance/roomGovernanceLogic";

export const ROOM_SESSION_POLICY_BUNDLE_ID = "room_session";
export const ROOM_SESSION_POLICY_BUNDLE_VERSION = 1;

export const ROOM_SESSION_ACTIVITY_MODULE = {
  moduleId: "badminton.rally",
  moduleVersion: "1",
};

/**
 * Compiled room_session policy (V1 parity).
 */
export function getRoomSessionPolicyBundle() {
  return {
    bundleId: ROOM_SESSION_POLICY_BUNDLE_ID,
    version: ROOM_SESSION_POLICY_BUNDLE_VERSION,
    lifecycle: {
      states: ["proposed", "prepared", "active", "paused", "completed", "cancelled"],
      initial: "proposed",
    },
    activity: {
      defaultModule: ROOM_SESSION_ACTIVITY_MODULE,
    },
    allocation: {
      allowConcurrentExclusiveParticipation: false,
    },
    managerLease: {
      useRoomMatchLockStaleMs: true,
    },
    offline: {
      allowOrchestrationQueue: false,
    },
    spectator: {
      publicActivityRead: true,
    },
  };
}

/**
 * V1 rule: each ref/deputy manages at most one ready/live room match; deputy may start while owner manages another.
 * @param {string | null | undefined} uid
 * @param {{ createdBy?: string, deputyRefereeUid?: string | null } | null} roomDoc
 * @param {{ matchStatus?: string; winner?: string | null; roomMatches?: unknown[] }} ctx
 */
export function roomSessionCanInitiateNewMatch(uid, roomDoc, ctx) {
  return canInitiateNewRoomSessionMatch(uid, roomDoc, ctx);
}

export { hasActiveLiveRoomSession };
